var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTopNewsMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 335 423",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M335 198.75V422.083H0V198.75H335ZM55 186.438H0V175.438H55V186.438ZM71.5 164.562H0V151.562H71.5V164.562ZM266.5 144.562H0V131.562H266.5V144.562ZM331.5 124.562H0V111.562H331.5V124.562ZM266.5 104.562H0V91.5625H266.5V104.562ZM200 76H0V56H200V76ZM330 48H0V28H330V48ZM270 20H0V0H270V20Z",
  fill: "#DFDFDF"
})));
export default SvgTopNewsMobile;